export function documentIcon(
  documentType: string = '',
  fileType: string = '',
  isFolder = false,
  expanded = false,
  defaultFolderKey: string = ''
): string {
  const type = (documentType || '').toLowerCase();
  const extension = (fileType || '').toLowerCase();
  let icon = 'pi-file';
  let tone = 'neutral';

  if (type.includes('undercompletion')) {
    icon = 'pi-file-edit';
    tone = 'coral';
  } else if (type === 'checklist' || type === 'checklists') {
    icon = 'pi-list-check';
    tone = 'coral';
  } else if (type.includes('form')) {
    icon = 'pi-file-edit';
    tone = 'amber';
  } else if (type === 'manual' || type === 'article') {
    icon = type === 'manual' ? 'pi-book' : 'pi-align-left';
    tone = 'blue';
  } else if (type === 'laws' || type === 'law' || type === 'regulation') {
    icon = 'pi-book';
  } else if (type === 'videos' || /^(mp4|webm|mov|avi)$/.test(extension)) {
    icon = 'pi-video';
    tone = 'teal';
  } else if (extension === 'pdf') {
    icon = 'pi-file-pdf';
    tone = 'red';
  } else if (/^(docx?|odt|rtf)$/.test(extension)) {
    icon = 'pi-file-word';
    tone = 'blue';
  } else if (/^(xlsx?|ods|csv)$/.test(extension)) {
    icon = 'pi-file-excel';
    tone = 'teal';
  } else if (/^(pptx?|odp)$/.test(extension)) {
    icon = 'pi-desktop';
    tone = 'amber';
  } else if (/^(png|jpe?g|gif|webp|svg|bmp|tiff?)$/.test(extension)) {
    icon = 'pi-image';
    tone = 'blue';
  } else if (/^(mp3|wav|ogg|m4a)$/.test(extension)) {
    icon = 'pi-volume-up';
    tone = 'teal';
  }

  if (isFolder) {
    icon = expanded ? 'pi-folder-open' : 'pi-folder';
    // Archive's default checklist folders can arrive as generic documents.
    const category = (defaultFolderKey || '')
      .toLowerCase()
      .replaceAll(' ', '_');
    if (
      category === 'checklist' ||
      category === 'checklists' ||
      type === 'fscompleted'
    ) {
      tone = 'coral';
    }
    if (tone === 'neutral' && type !== 'laws' && type !== 'regulation') {
      tone = 'amber';
    }
  }

  return `pi ${icon} kuba-document-icon kuba-document-icon--${tone}`;
}
